import React, { useRef, useEffect, useState } from "react";

import styles from "./YearList.module.css";

const YearList = ({onChangeYear}) => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    const [years, setYears] = useState([]);

    const scrollContainerRef = useRef(null);

    const scrollLeft = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({left: -200, behavior: "smooth"});
        }
    };

    const scrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({left: 200, behavior: "smooth"});
        }
    };

    useEffect(() => {
        const fetchYearData = async () => {
            try {
                const response = await fetch(`${API_URL}/common/get_biokem_year_list.php`);
                const data = await response.json();
                setYears(data);
            } catch (error) {
                console.error('Error fetching journals:', error);
            }
        };
        fetchYearData();
    }, []);

    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({
                left: scrollContainerRef.current.scrollWidth
                //behavior: 'smooth',
            });
        }
    }, [years]);

    return (
            <div className={styles.yearListWrapper}>
                <button className={`${styles.scrollButton} ${styles.left}`} onClick={scrollLeft}>
                    ◁
                </button>
                <div className={styles.yearListContainer} ref={scrollContainerRef}>
                    {years.map((year) => (
                                        <button
                                            key={year}
                                            onClick={() => onChangeYear(year)}
                                            className={styles.yearLink}
                                            >
                                            {year}
                                        </button>
                                            ))}
                </div>
                <button className={`${styles.scrollButton} ${styles.right}`} onClick={scrollRight}>
                    ▷
                </button>
            </div>
            );
};

export default YearList;
